import axios from 'axios';

const http = axios.create();

http.interceptors.response.use(
  response => {
    // If the response is OK, return it
    return response;
  },
  error => {
    // If the response status is 400, we return a resolved promise
    if (error.response && error.response.status < 500) {
      return Promise.resolve(error.response);
    }

    // If the response status is not 400, we just propagate the error
    return Promise.reject(error);
  }
);

export default http;
